import { useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'
import { ZENDESK_URL } from 'config'

// Custom components
import { NewCardButton } from 'components/CardButtons'
import PageWrapper from 'components/PageWrapper'

const BUTTONS = [
  {
    title: 'Préstamo',
    url: `${ZENDESK_URL}/articles/26888099379995-MODELO-DE-CONTRATO-DE-ADHESI%C3%93N-SOLICITUD-DE-PR%C3%89STAMO`,
    event: 'bille_legales_contratos_prestamo'
  },
  {
    title: 'Adelantos',
    url: `${ZENDESK_URL}/articles/26888248233371-MODELO-DE-CONTRATO-DE-ADHESI%C3%93N-SOLICITUD-DE-ADELANTO`,
    event: 'bille_legales_contratos_adelantos'
  },
  {
    title: 'Tarjetas',
    url: `${ZENDESK_URL}/articles/26887933310875-MODELO-DE-CONTRATO-DE-ADHESI%C3%93N-TARJETAS-WAYNI`,
    event: 'bille_legales_contratos_tarjetas'
  },
  {
    title: 'Membresía',
    url: `${ZENDESK_URL}/articles/26888350450971-MODELO-DE-CONTRATO-DE-ADHESI%C3%93N-MEMBRES%C3%8DA-WAYNI`,
    event: 'bille_legales_contratos_membresia'
  }
]

const AdhesionContracts = () => {
  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_legales_contratos' })
  }, [])

  return (
    <PageWrapper
      viewSelected='/centro-de-ayuda'
      className='!px-0 md:px-4'
      title='Contratos de adhesión (Ley 24.240)'
      noTabBar
    >
      <section className='px-4 mt-4 text-black md:flex md:max-w-564 md:flex-col mb-20 md:mb-5 mx-auto'>
        <div className='space-y-4'>
          {BUTTONS.map((item) => (
            <NewCardButton
              key={item.title}
              onClick={() => {
                trackEvent({ eventName: item.event })
                window.open(item.url, '_blank')
              }}
            >
              <span className='text-purple-900 text-xs font-bold'>
                {item.title}
              </span>
            </NewCardButton>
          ))}
        </div>
      </section>
    </PageWrapper>
  )
}

export default AdhesionContracts
